import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { FilterControls } from 'components/FiltersControls';
import { Heading } from 'components/Heading';
import { ModalButton } from 'components/ModalButton';
import { Table } from 'components/Table';
import { TinySkinPreview } from 'components/TinySkinPreview';
import { emitMessage } from 'engine/api';
import { isRouteAllowed } from 'engine/appConfig';
import { Copy, Pencil, Plus, Trash2 } from 'lucide-react';
import { useState } from 'react';

export const Route = createFileRoute('/dashboard/skins/')({
	component: RouteComponent,

	loader: async () => emitMessage({ kind: 'skin-list' }),

	beforeLoad: () => {
		isRouteAllowed('allowSkins');
	},
});

function RouteComponent() {
	const data = Route.useLoaderData();
	const router = useRouter();
	console.log(data.skins);

	const [skins, setSkins] = useState(data.skins);

	return (
		<div className="flex flex-col gap-3">
			<div className="border-yellow flex items-center gap-3">
				<Heading>Skins</Heading>
				<Button to="/dashboard/skins/new">
					New Skin <Plus className="size-4" />
				</Button>
			</div>
			<FilterControls
				items={data.skins || []}
				getSearchableText={(s) => s.skin.name}
				sortOptions={[
					{
						key: 'name',
						label: 'Name',
						sortFn: (a, b) => a.skin.name.localeCompare(b.skin.name),
					},
					{
						key: 'createdAt',
						label: 'Creation date',
						sortFn: (a, b) => a.createdAt.localeCompare(b.createdAt),
					},
					{
						key: 'updatedAt',
						label: 'Last updated',
						sortFn: (a, b) => a.updatedAt.localeCompare(b.updatedAt),
					},
				]}
				onChanged={setSkins}
			/>
			{!data.success && <span>Could not get games.</span>}
			{data.success && (
				<Table
					className="w-fit"
					headers={['Name', 'Preview', 'Actions']}
					rows={skins!.map((s) => [
						//
						<span className="font-bold">{s.skin.name}</span>,
						<TinySkinPreview skin={s.skin} />,
						<div className="flex gap-1">
							<Button to={'/dashboard/skins/edit/$id'} params={{ id: s.id }} mode="primary" className="p-1">
								<Pencil />
							</Button>
							<ModalButton
								title={`Make a copy of "${s.skin.name}"?`}
								onAccept={async () => {
									await emitMessage({ kind: 'skin-copy', id: s.id });
									router.navigate({ to: '/dashboard/skins' });
								}}
								mode={'secondary'}
								className="border-2 border-gray-200 p-1"
							>
								<Copy />
							</ModalButton>
							<ModalButton
								title={`Are you sure you want to delete "${s.skin.name}"? Make sure you're not using it.`}
								onAccept={async () => {
									await emitMessage({ kind: 'skin-delete', id: s.id });
									router.navigate({ to: '/dashboard/skins' });
								}}
								mode={'secondary'}
								className="border-2 border-gray-200 p-1"
							>
								<Trash2 />
							</ModalButton>
						</div>,
					])}
				></Table>
			)}
			{/* <Code block>{JSON.stringify(data.skins, null, 2)}</Code> */}
		</div>
	);
}
